import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StockCountHistoryAction } from './stock-count-history.actions';
import { StockCountHistoryService } from '../../service/stock-count-history.service';

@Injectable()
export class StockCountHistoryEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: StockCountHistoryService
  ) {}

  loadStockCountHistoryListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockCountHistoryAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Stock Count History List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.service.getStockCountHistoryList(action.criteriaObj).pipe(
          map((data: any) => StockCountHistoryAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
